import { render, staticRenderFns } from "./Devize_in_lucru_list.vue?vue&type=template&id=30a91d05&scoped=true&"
import script from "./Devize_in_lucru_list.vue?vue&type=script&lang=js&"
export * from "./Devize_in_lucru_list.vue?vue&type=script&lang=js&"
import style0 from "./Devize_in_lucru_list.vue?vue&type=style&index=0&id=30a91d05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a91d05",
  null
  
)

export default component.exports